export default "__VITE_ASSET__BchVT2Ly__"